// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";

export interface ResetPasswordUserNameFieldPresentationProps extends TextFieldPresentationProps {}

export interface ResetPasswordUserNameFieldProps
    extends Omit<TextFieldProps, "disabled" | "readOnly" | "type" | "value"> {}

/**
 * Shows the email of the account being activated.
 *
 * The value comes from the session properties bag, populated for the reset-password page by the
 * backend GetSessionHandler/0705_AddUserEmailToSessionResponse from the userId on the URL -- the
 * user is not authenticated at this point, so it cannot come from the profile.
 */
const ResetPasswordUserNameField: FC<ResetPasswordUserNameFieldProps> = ({ className, ...otherProps }) => {
    const session = useSession();

    return (
        <TextField
            className={className ? `${className} disabled` : "disabled"}
            label={translate("Email")}
            readOnly
            type="text"
            value={session?.properties?.userEmail ?? ""}
            {...otherProps}
        />
    );
};

export default ResetPasswordUserNameField;
